import React from 'react';
import PropTypes from 'prop-types';

const HeaderAndError = ({ label, required, style }) => {
    const className = style || 'text-xl text-teal-700 font-bold leading-6 py-4';
    return (
        <h1 className={className}>
            {label}{' '}
            {required && <span className="text-lg text-red-500 py-4"> * </span>}
        </h1>
    );
};

HeaderAndError.propTypes = {
    label: PropTypes.string,
    required: PropTypes.bool,
    style: PropTypes.string,
};

export default HeaderAndError;
